var map = {
	"./Anyswap.png": 767,
	"./Anyswap.svg": 768,
	"./Artwork.svg": 769,
	"./Banxa.png": 770,
	"./DROP_DOWN.svg": 342,
	"./Hop.png": 771,
	"./Hop.svg": 772,
	"./Hop_dark.png": 773,
	"./Hop_dark.svg": 774,
	"./Synapse.png": 775,
	"./Synapse.svg": 776,
	"./arrow-left.svg": 777,
	"./background_mesh.png": 778,
	"./background_mesh_mobile.png": 357,
	"./binance.png": 779,
	"./bscscan.png": 780,
	"./btn_big_arbitrum.png": 781,
	"./btn_big_avalanche.png": 782,
	"./btn_big_bsc.png": 783,
	"./buy_transfer_eth.svg": 784,
	"./chevron-down.svg": 226,
	"./close-rounded.png": 785,
	"./close.svg": 352,
	"./coinbaseWallet.png": 290,
	"./coingecko.png": 786,
	"./copy.svg": 225,
	"./cross.svg": 787,
	"./discord.svg": 788,
	"./earn/esmyc.svg": 341,
	"./earn/eth.svg": 288,
	"./earn/myc.svg": 340,
	"./event-modal-header-mesh.png": 789,
	"./event-modal-header.png": 790,
	"./external-link.svg": 791,
	"./gitbook.svg": 792,
	"./github.svg": 793,
	"./glp_icon.svg": 794,
	"./graphite-01.png": 795,
	"./ic-communityproject.svg": 796,
	"./ic_arbitrum_16.svg": 222,
	"./ic_arbitrum_24.svg": 223,
	"./ic_arbitrum_96.svg": 797,
	"./ic_arbitrum_hover_16.svg": 798,
	"./ic_avalanche_16.svg": 799,
	"./ic_avalanche_24.svg": 461,
	"./ic_avalanche_96.svg": 800,
	"./ic_bal_24.svg": 462,
	"./ic_bal_40.svg": 445,
	"./ic_banxa.svg": 801,
	"./ic_binance_logo.svg": 802,
	"./ic_bsc.svg": 803,
	"./ic_bsc_96.svg": 804,
	"./ic_btc_24.svg": 463,
	"./ic_btc_40.svg": 446,
	"./ic_busd_24.svg": 464,
	"./ic_cash.png": 805,
	"./ic_cash.svg": 806,
	"./ic_coingecko_16.svg": 337,
	"./ic_coingecko_hover_16.svg": 807,
	"./ic_convert_down.svg": 346,
	"./ic_copy_16.svg": 354,
	"./ic_cost.svg": 808,
	"./ic_crv_24.svg": 465,
	"./ic_crv_40.svg": 447,
	"./ic_dai_24.svg": 466,
	"./ic_dai_40.svg": 448,
	"./ic_degen.svg": 347,
	"./ic_discord.svg": 809,
	"./ic_eth_24.svg": 467,
	"./ic_eth_40.svg": 331,
	"./ic_frax_24.svg": 468,
	"./ic_frax_40.svg": 449,
	"./ic_fxs_24.svg": 469,
	"./ic_fxs_40.svg": 450,
	"./ic_github.svg": 810,
	"./ic_gmx_arbitrum.svg": 811,
	"./ic_hop.svg": 812,
	"./ic_info.svg": 813,
	"./ic_link_24.svg": 470,
	"./ic_link_40.svg": 451,
	"./ic_liquidity.svg": 814,
	"./ic_medium.svg": 815,
	"./ic_metamask_16.svg": 338,
	"./ic_metamask_hover_16.svg": 816,
	"./ic_mim_24.svg": 471,
	"./ic_mim_40.svg": 452,
	"./ic_mlp_24.svg": 224,
	"./ic_mlp_40.svg": 149,
	"./ic_mlp_custom.svg": 817,
	"./ic_multiswap.svg": 818,
	"./ic_myc.svg": 336,
	"./ic_myc_40.svg": 268,
	"./ic_myc_custom.svg": 819,
	"./ic_nav_close.svg": 358,
	"./ic_new_link_16.svg": 353,
	"./ic_olympus.svg": 820,
	"./ic_olympus_arbitrum.svg": 821,
	"./ic_ppusd_24.svg": 472,
	"./ic_ppusd_40.svg": 453,
	"./ic_selector_dropdowns.svg": 241,
	"./ic_settings_16.svg": 355,
	"./ic_sign in_16.svg": 822,
	"./ic_sign_out_16.svg": 356,
	"./ic_simpleswaps.svg": 823,
	"./ic_stats.svg": 824,
	"./ic_stats_big.svg": 825,
	"./ic_synapse.svg": 826,
	"./ic_tcr_24.svg": 473,
	"./ic_tcr_40.svg": 454,
	"./ic_telegram.svg": 827,
	"./ic_test_40.svg": 455,
	"./ic_tether_24.svg": 474,
	"./ic_tokens.svg": 828,
	"./ic_totaluser.svg": 829,
	"./ic_trading.svg": 830,
	"./ic_twitter.svg": 831,
	"./ic_uni_24.svg": 475,
	"./ic_uni_40.svg": 456,
	"./ic_usdc.e_24.svg": 476,
	"./ic_usdc.e_40.svg": 457,
	"./ic_usdc_24.svg": 477,
	"./ic_usdc_40.svg": 458,
	"./ic_usdt_24.svg": 478,
	"./ic_usdt_40.svg": 459,
	"./ic_wallet_24.svg": 186,
	"./ic_weth_24.svg": 479,
	"./ic_weth_40.svg": 460,
	"./lg_arbitrum.svg": 832,
	"./live.svg": 349,
	"./logo_MYC.svg": 144,
	"./logo_MYC_small.svg": 291,
	"./logo_TRS.svg": 833,
	"./logo_TRS_small.svg": 834,
	"./long.svg": 343,
	"./metamask-text.svg": 835,
	"./metamask.png": 292,
	"./myc_pools.svg": 836,
	"./myc_pools_short.svg": 359,
	"./myc_pools_switch.svg": 837,
	"./myc_swaps.svg": 838,
	"./nav/analytics.svg": 839,
	"./nav/buy.svg": 840,
	"./nav/chevron-down.svg": 841,
	"./nav/chevron-left.svg": 842,
	"./nav/dashboard.svg": 843,
	"./nav/discord.svg": 844,
	"./nav/docs.svg": 845,
	"./nav/earn.svg": 846,
	"./nav/event-graphic.png": 360,
	"./nav/github.svg": 847,
	"./nav/live.svg": 227,
	"./nav/logos/pools.svg": 848,
	"./nav/logos/staking.svg": 849,
	"./nav/logos/token-migration.svg": 850,
	"./nav/medium.svg": 851,
	"./nav/myc-icon.svg": 852,
	"./nav/myc-staking.svg": 853,
	"./nav/pull-tab.svg": 854,
	"./nav/referrals.svg": 855,
	"./nav/rewards.svg": 856,
	"./nav/trade.svg": 857,
	"./nav/trading-leaderboard.svg": 858,
	"./nav/translate.svg": 859,
	"./nav/twitter.svg": 860,
	"./page-not-found.svg": 361,
	"./position-indicator.svg": 861,
	"./referrals-comp/20k.svg": 862,
	"./referrals-comp/first.svg": 289,
	"./referrals-comp/podium-background.png": 348,
	"./referrals-comp/second.svg": 350,
	"./referrals-comp/third.svg": 351,
	"./short.svg": 344,
	"./swap.svg": 345,
	"./trading.png": 863,
	"./twitter-icon.svg": 864,
	"./twitter.svg": 865,
	"./wallet-connect-text.svg": 866,
	"./walletconnect-circle-blue.svg": 293,
	"./wave-01.png": 867,
	"./wave-02.png": 868
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 264;